/**
 * Palette Slice - UI state for node palette and drag-drop
 * Manages palette visibility and drag state
 */

import type { StateCreator } from 'zustand';
import type { WorkflowStore, PaletteSlice } from './types';

export const createPaletteSlice: StateCreator<WorkflowStore, [], [], PaletteSlice> = (set) => ({
  // Initial State
  isPaletteOpen: true, // Palette visible by default
  isDragging: false,
  draggedNodeType: null,

  // Actions
  setIsPaletteOpen: (isOpen) => {
    set({ isPaletteOpen: isOpen });
  },

  togglePalette: () => {
    set((state) => ({ isPaletteOpen: !state.isPaletteOpen }));
  },

  setIsDragging: (isDragging) => {
    set({ isDragging });
  },

  setDraggedNodeType: (nodeType) => {
    set({
      draggedNodeType: nodeType,
      isDragging: nodeType !== null
    });
  }
});
